import { Link } from "react-router-dom";
import NewsletterForm from "@/components/site/NewsletterForm";

export default function Footer() {
    return (
        <footer
            className="bg-[#0c0f3d] text-[#fbf9f8] relative overflow-hidden"
            data-testid="site-footer"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-20 md:py-28">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
                    <div className="lg:col-span-5">
                        <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#ffb5ab] mb-6">
                            Stay Connected
                        </p>
                        <h3 className="font-serif text-4xl md:text-5xl leading-[1.05] tracking-tight mb-6">
                            Architecture for the next era of human connection.
                        </h3>
                        <p className="font-sans text-base text-[#e3c7b9]/80 max-w-md mb-8 leading-relaxed">
                            Join leaders, deans, and changemakers receiving frameworks,
                            field notes, and event invites from Shana Price.
                        </p>
                        <NewsletterForm variant="dark" />
                    </div>

                    <div className="lg:col-span-7 grid grid-cols-2 sm:grid-cols-3 gap-8">
                        <div>
                            <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#6d91ad] mb-5">Explore</p>
                            <ul className="space-y-3 font-sans text-sm">
                                <li><Link to="/" className="hover:text-[#ffb5ab] transition-colors" data-testid="footer-link-home">Home</Link></li>
                                <li><Link to="/about" className="hover:text-[#ffb5ab] transition-colors" data-testid="footer-link-about">About Shana</Link></li>
                                <li><Link to="/services" className="hover:text-[#ffb5ab] transition-colors" data-testid="footer-link-services">Services</Link></li>
                                <li><Link to="/contact" className="hover:text-[#ffb5ab] transition-colors" data-testid="footer-link-contact">Contact</Link></li>
                            </ul>
                        </div>
                        <div>
                            <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#6d91ad] mb-5">Offerings</p>
                            <ul className="space-y-3 font-sans text-sm">
                                <li><Link to="/services" className="hover:text-[#ffb5ab] transition-colors">9-Module Curriculum</Link></li>
                                <li><Link to="/services" className="hover:text-[#ffb5ab] transition-colors">Workshops</Link></li>
                                <li><Link to="/services" className="hover:text-[#ffb5ab] transition-colors">Keynotes</Link></li>
                                <li><Link to="/services" className="hover:text-[#ffb5ab] transition-colors">Faculty Training</Link></li>
                            </ul>
                        </div>
                        <div>
                            <p className="font-sans text-xs uppercase tracking-[0.25em] text-[#6d91ad] mb-5">Connect</p>
                            <ul className="space-y-3 font-sans text-sm">
                                <li>
                                    <Link
                                        to="/book"
                                        className="hover:text-[#ffb5ab] transition-colors"
                                        data-testid="footer-link-book"
                                    >
                                        Book a Consultation
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/contact" className="hover:text-[#ffb5ab] transition-colors">
                                        Inquiry Form
                                    </Link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-20 pt-10 border-t border-[#6d91ad]/30 flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
                    <p className="font-sans text-xs text-[#e3c7b9]/60">
                        &copy; {new Date().getFullYear()} The Connection Guru&reg;. All rights reserved.
                    </p>
                    <p className="font-sans text-xs text-[#e3c7b9]/60 italic">
                        Architecting connection&#8209;centered ecosystems.
                    </p>
                </div>
            </div>

            <div className="font-serif text-[18vw] leading-none text-[#6d91ad]/[0.06] tracking-tighter -mb-8 px-2 select-none pointer-events-none whitespace-nowrap">
                connection.
            </div>
        </footer>
    );
}
